import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import cx from "classnames";
import structuredClone from "@ungap/structured-clone";
import { CAF, containerType, DECAF, decideVersion, FLAVOR_BOOST_PICKER, GREENS, HIGH_STIM, HYDRATION, lemonginger, LOSE_WEIGHT, LOW_STIM, LOW_SWEAT, MANGO, MED_STIM, pageCopy, prettifyOption, PREWORKOUT, PROTEIN, questionOptions, SELECTOR, WATERMELON, WHEY_BASED, } from "../data";
import { mapServerProductToClient, } from "../../../../lib/slices/createCartSlice";
import FlavorPicker, { data as flavorData } from "../FlavorPicker";
import styles from "./styles.module.scss";
import { useHistory } from "react-router";
import { useScreenWidth } from "Root/quiz/hooks/useScrollHook";
import { useAppStore } from "Root/profile/lib/store";
import httpService from "Root/api/httpService";
import { CUSTOMIZED_PRODUCTS, QuantityInput, QuestionWrapper } from "..";
import SelectorGroup from "../SelectorGroup";
import Button from "Root/profile/components/common/Button";
import { useDispatch, useSelector } from "react-redux";
import { LoadUserCartThunk } from "Root/profile/redux/thunkCreators/products/userCart";
import { setGlobalLoading } from "Root/profile/redux/actionCreators/makeActionCreator";
import { LoadPricingThunk } from "Root/profile/redux/thunkCreators/orders/pricing";
import toastService from "Root/profile/toastService";
import DrawerComponent from "Root/profile/components/common/DrawerComponent";
import FlavorAccordion from "../FlavorAccordion";
import posthog from "posthog-js";
import { cvgTrack, VIEWED_PRODUCT } from "Root/utils/tracking";
export const formatPrice = (cents) => {
    const dollars = cents / 100;
    return `$${dollars.toFixed(2)}`;
};
export const buildQuantityString = (quantity, category) => {
    const countType = quantity > 1 ? "plural" : "singular";
    if (category.toUpperCase() in containerType) {
        return (quantity.toString() +
            " " +
            containerType[category.toUpperCase()][countType]);
    }
    return quantity.toString();
};
const sumValues = (obj) => {
    return Object.values(obj).reduce((acc, curr) => acc + curr, 0);
};
const DEFAULT = {
    [PROTEIN]: {
        PROTEIN_BASE: WHEY_BASED,
        GOAL_BOOST: LOSE_WEIGHT,
        FLAVORS: {
            variety: 2,
        },
    },
    [HYDRATION]: {
        FLAVOR: MANGO,
        CAFFEINE: CAF,
        SWEAT: LOW_SWEAT,
    },
    [PREWORKOUT]: {
        FLAVOR: WATERMELON,
        CAFFEINE: CAF,
        STIM_LEVEL: HIGH_STIM,
    },
    [GREENS]: {
        FLAVOR: lemonginger,
    },
};
export const formatFlavorBoostsString = (chosenFlavors) => {
    const fullFlavorNames = Object.keys(chosenFlavors)
        .filter((sku) => !!chosenFlavors[sku])
        .map((sku) => {
        const flavorDataItem = flavorData.find((item) => sku === item.sku);
        return (flavorDataItem?.name +
            (chosenFlavors[sku] > 1 ? ` x${chosenFlavors[sku]}` : ""));
    })
        .join(", ");
    return fullFlavorNames;
};
const Customizer = ({ productType, editMode = false, skuToModify, toggleDrawer, existingValues, existingQuantity, }) => {
    const history = useHistory();
    const userCart = useSelector((state) => state.userCart);
    const width = useScreenWidth();
    const isMobile = width < 968;
    const [products, setProducts] = useState([]);
    useEffect(() => {
        const interval = setInterval(() => {
            const launcher = document.getElementById("launcher");
            if (launcher) {
                launcher.style.zIndex = "999";
                if (isMobile) {
                    launcher.style.bottom = "94px";
                    launcher.style.transition = "none";
                    launcher.style.transition = "opacity 0.2 ease-in-out";
                }
                else {
                    launcher.style.bottom = "0";
                }
            }
        }, 1000);
        return () => {
            clearInterval(interval);
        };
    });
    function valueExistsInOptions(productType, key, newValue) {
        // Check if productType exists in questionOptions
        if (!questionOptions[productType]) {
            return false;
        }
        // Iterate through all objects in the array for the given productType
        for (const questionObj of questionOptions[productType]) {
            // Check if 'name' of the current question object equals key
            if (questionObj.name === key) {
                // Check if current object has 'options' property and it's an array
                if (Array.isArray(questionObj.options)) {
                    // Iterate through all option objects in the options array
                    for (const option of questionObj.options) {
                        // Check if 'value' of the current option object equals newValue
                        if (option.value === newValue) {
                            return true;
                        }
                    }
                }
            }
        }
        // Return false if no match was found
        return false;
    }
    function validProteinFlavor(flavor) {
        return flavorData.some((item) => item.sku === flavor);
    }
    useEffect(() => {
        const query_params = Object.fromEntries(new URLSearchParams(window.location.search));
        const param_options = {
            HYDRATION: ["FLAVOR", "CAFFEINE", "SWEAT"],
            PREWORKOUT: ["FLAVOR", "CAFFEINE", "STIM_LEVEL"],
            PROTEIN: ["GOAL_BOOST", "PROTEIN_BASE", "FLAVORS"],
            GREENS: ["FLAVOR"],
        };
        const newVals = structuredClone(values);
        for (const key in query_params) {
            if (productType in param_options) {
                //@ts-ignore
                if (param_options[productType]?.includes(key)) {
                    const newValue = query_params[key];
                    if (productType === PROTEIN && key === "FLAVORS") {
                        if (validProteinFlavor(newValue)) {
                            //@ts-ignore
                            newVals[productType][key] = { [newValue]: 2 };
                        }
                    }
                    else if (valueExistsInOptions(productType, key, newValue)) {
                        newVals[productType][key] = newValue;
                    }
                }
            }
        }
        setValues(newVals);
        fetchData();
    }, []);
    const [quantity, setQuantity] = useState(existingQuantity || 1);
    const [isOpen, setIsOpen] = useState(false);
    const { addToast } = useAppStore();
    const dispatch = useDispatch();
    const addToSubscription = async (sku, skuToReplace) => {
        const endpoint = `/api/v2/next-order-cart/`;
        // construct new cart with added item
        let cart = [
            ...userCart
                .filter((item) => {
                return item.sku !== sku.toLowerCase();
            })
                .map((item) => ({ sku: item.sku, quantity: item.quantity })),
        ];
        // if updating an item's sku, remove old sku
        if (skuToReplace) {
            cart = cart.filter((item) => item.sku !== skuToReplace);
        }
        cart.push({ sku, quantity });
        // remove all existing non-additional flavors from cart
        const flavorSkus = flavorData.map((flavor) => flavor.sku);
        cart = cart.filter((item) => !flavorSkus.includes(item.sku));
        // add flavors from new product to cart, if the new product is protein
        if (productType === PROTEIN) {
            const flavors = Object.keys(values[PROTEIN].FLAVORS).map((item) => ({
                sku: item,
                quantity: values[PROTEIN].FLAVORS[item],
            }));
            cart.push(...flavors);
        }
        // add all existing flavor boosts to cart
        const proteins = userCart.filter((item) => item.item_type === "protein" && item.sku !== skuToReplace);
        let flavorsToAdd = [];
        proteins.forEach((proteinItem) => {
            const flavs = proteinItem.flavors.map((flavor) => ({
                sku: flavor.short_name,
                quantity: 1,
            }));
            flavorsToAdd.push(...flavs);
        });
        // remove extra flavors if there are any present
        if (flavorsToAdd.length > proteins.length * 2) {
            flavorsToAdd = flavorsToAdd.slice(0, proteins.length * 2);
        }
        const combinedCart = [...cart, ...flavorsToAdd];
        // merge duplicate skus and add quantities together
        const mergedCartItems = combinedCart
            .reduce((acc, cartItem) => {
            const existingCartItem = acc.find((f) => f.sku === cartItem.sku);
            if (existingCartItem) {
                existingCartItem.quantity += cartItem.quantity;
            }
            else {
                acc.push(cartItem);
            }
            return acc;
        }, [])
            .filter((i) => i.quantity);
        await httpService.post(endpoint, { items: mergedCartItems });
        dispatch(setGlobalLoading(true));
        await dispatch(LoadUserCartThunk());
        await dispatch(LoadPricingThunk());
        dispatch(setGlobalLoading(false));
        history.push("/app/subscription/");
        toastService.successMessage("Item added to subscription!");
    };
    const copy = pageCopy[productType] || {};
    const [values, setValues] = useState(existingValues || DEFAULT);
    const setQuantitySafe = (qty) => {
        if (qty > 4) {
            return addToast("You can only add up to 4 items to your subscription", "error", 3000);
        }
        const newMaxItems = qty * 2;
        const currentFlavorStickQty = sumValues(values[PROTEIN].FLAVORS);
        if (productType === PROTEIN &&
            newMaxItems < currentFlavorStickQty &&
            qty < quantity) {
            const sticksToRemove = currentFlavorStickQty - newMaxItems;
            setIsOpen(true);
            addToast(`Remove ${sticksToRemove} flavor sticks to decrease quantity`, "error", 3000);
        }
        else {
            setQuantity(qty);
        }
    };
    // drawer control
    const [nutritionVisible, setNutritionVisible] = useState(false);
    const [flavorNutritionVisible, setFlavorNutritionVisible] = useState(false);
    const updateValue = (productType, field, value) => {
        const newVals = structuredClone(values);
        if (productType === PREWORKOUT) {
            if (values[PREWORKOUT].CAFFEINE == DECAF &&
                field == "STIM_LEVEL" &&
                (value == LOW_STIM || value === HIGH_STIM)) {
                newVals[PREWORKOUT].CAFFEINE = CAF;
            }
            if (values[PREWORKOUT].CAFFEINE == CAF &&
                field == "CAFFEINE" &&
                value == DECAF) {
                newVals[PREWORKOUT].STIM_LEVEL = MED_STIM;
            }
        }
        newVals[productType][field] = value;
        setValues(newVals);
    };
    const updateProteinFlavors = (sku, direction) => {
        const newProteinFlavors = structuredClone(values[PROTEIN].FLAVORS);
        if (direction === "increment") {
            const maxItems = quantity * 2;
            const totalPicks = Object.values(newProteinFlavors).reduce((acc, val) => acc + val, 0);
            if (maxItems - totalPicks > 0) {
                newProteinFlavors[sku] = (newProteinFlavors[sku] || 0) + 1;
            }
            else {
                addToast("Maximum amount of flavor boosts selected", "error");
            }
        }
        if (direction === "decrement") {
            if (newProteinFlavors[sku] > 0) {
                // eslint-disable-next-line operator-assignment
                newProteinFlavors[sku] = newProteinFlavors[sku] - 1;
            }
        }
        const newValues = structuredClone(values);
        newValues[PROTEIN].FLAVORS = newProteinFlavors;
        setValues(newValues);
    };
    const fetchData = async () => {
        const data = await httpService.get(`/api/v2/products/?type=${productType.toLowerCase()}`);
        setProducts(data);
    };
    const [currentProduct, setCurrentProduct] = useState(undefined);
    const hasItemInCart = userCart.find((item) => item.sku === currentProduct?.productId);
    useEffect(() => {
        const productId = decideVersion(productType, values);
        const po = prettifyOption;
        let customizations = "";
        if (productType === PROTEIN) {
            const vals = values[PROTEIN];
            customizations = `${po(vals.PROTEIN_BASE)}, ${po(vals.GOAL_BOOST)}`;
        }
        if (productType === HYDRATION) {
            const vals = values[HYDRATION];
            customizations = `${po(vals.CAFFEINE)}, ${po(vals.SWEAT)}`;
        }
        if (productType === PREWORKOUT) {
            const vals = values[PREWORKOUT];
            customizations = `${po(vals.CAFFEINE)}, ${po(vals.STIM_LEVEL)}`;
        }
        const matchingProduct = products?.find((product) => product.product_id === productId);
        if (matchingProduct) {
            const newProduct = {
                ...mapServerProductToClient(matchingProduct),
                customizations,
                quantity,
            };
            setCurrentProduct(newProduct);
            const qtyKey = quantity === 1 ? 1 : 2;
            const price = newProduct.unit_prices[qtyKey];
            const eventProperties = {
                product_id: newProduct.productId,
                name: newProduct.title,
                price: price / 100,
                currency: "USD",
            };
            cvgTrack({
                eventName: VIEWED_PRODUCT,
                properties: eventProperties,
            });
        }
    }, [values, products, quantity]);
    // make a list of all the flavors picked for the protein page
    const flavorValues = values[PROTEIN].FLAVORS;
    // how many flavor sticks are in the displayed flavors on the selector box (this is an acc value)
    let shownQty = 0;
    // how many flavors are in the displayed flavors selector box' (this is a hardcoded setting)
    const shownFlavorNumber = 2;
    // total flavor sticks
    const totalFlavorSticksPicked = sumValues(flavorValues);
    const flavorNames = Object.keys(flavorValues)
        .filter((sku) => !!flavorValues[sku])
        .map((sku, index) => {
        const flavorDataItem = flavorData.find((item) => sku === item.sku);
        const qty = flavorValues[sku] > 1 ? ` x${flavorValues[sku]}` : "";
        if (index < shownFlavorNumber) {
            shownQty += flavorValues[sku];
        }
        return flavorDataItem?.name + qty;
    })
        .filter((x) => !!x);
    const andMore = `, + ${totalFlavorSticksPicked - shownQty}`;
    const displayedFlavorNames = flavorNames.slice(0, 2).join(", ") +
        `${flavorNames.length > 2 ? andMore : ""}`;
    return (_jsxs("div", { children: [_jsxs("div", { className: styles.form, children: [!CUSTOMIZED_PRODUCTS.includes(productType.toLowerCase()) && (_jsx("div", { className: cx(styles.nutritionCta), style: { marginBottom: 0 }, children: _jsx(Button, { onClick: () => {
                                setNutritionVisible(true);
                            }, underlined: true, nutrition: true, variant: "secondary", children: "Nutrition Label" }) })), _jsx(QuestionWrapper, { title: "Quantity", isQuantity: true, children: _jsxs("div", { className: styles.twoColumns, children: [_jsx(QuantityInput, { value: quantity, setValue: setQuantitySafe }), _jsx("div", { className: styles.servingsPerItem, children: copy.qty })] }) }), CUSTOMIZED_PRODUCTS.includes(productType.toLowerCase()) && (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.proteinBox, children: [questionOptions[productType]
                                        ?.filter((data) => data.type !== FLAVOR_BOOST_PICKER)
                                        .map((data) => {
                                        const validatedOptions = data.options?.map((opt) => {
                                            if (productType !== PREWORKOUT) {
                                                return opt;
                                            }
                                            const newOpt = { ...opt };
                                            if (values[PREWORKOUT].CAFFEINE === DECAF &&
                                                (newOpt.value === LOW_STIM ||
                                                    newOpt.value === HIGH_STIM)) {
                                                newOpt.disabled = true;
                                            }
                                            else if ((values[PREWORKOUT].STIM_LEVEL === LOW_STIM ||
                                                values[PREWORKOUT].STIM_LEVEL === HIGH_STIM) &&
                                                newOpt.value === DECAF) {
                                                newOpt.disabled = true;
                                            }
                                            else {
                                                newOpt.disabled = false;
                                            }
                                            return newOpt;
                                        }) || [];
                                        return (_jsx(React.Fragment, { children: data.type === SELECTOR && (_jsx(QuestionWrapper, { title: data.title, subhed: data.subhed, tooltip: data.tooltip, children: _jsx(SelectorGroup, { maxChoices: 1, values: values[productType][data.name], setValues: (val) => updateValue(productType, data.name, val), options: validatedOptions, variant: data.variant }) }, data.title)) }, data.title));
                                    }), productType === PROTEIN && (_jsx("div", { className: cx(styles.nutritionCta), children: _jsxs(Button, { onClick: () => {
                                                setNutritionVisible(true);
                                            }, underlined: true, nutrition: true, variant: "secondary", children: [productType === PROTEIN ? "Protein " : "", "Nutrition Label"] }) }))] }), _jsxs("div", { className: styles.proteinBox, children: [questionOptions[productType]
                                        ?.filter((data) => data.type === FLAVOR_BOOST_PICKER)
                                        .map((data) => {
                                        return (_jsx(React.Fragment, { children: data.type === FLAVOR_BOOST_PICKER && (_jsx(QuestionWrapper, { title: `Select ${quantity * 2} Flavor Boosts`, subhed: data.subhed, tooltip: data.tooltip, titleRight: `(${totalFlavorSticksPicked}/${quantity * 2})`, titleRightClass: totalFlavorSticksPicked === quantity * 2
                                                    ? styles.titleRightSuccess
                                                    : undefined, children: _jsx(FlavorPicker, { updateValues: updateProteinFlavors, values: values[PROTEIN].FLAVORS, text: displayedFlavorNames, maxItems: quantity * 2, isOpen: isOpen, setIsOpen: setIsOpen }) }, data.title)) }, data.title));
                                    }), productType !== PROTEIN && (_jsx("div", { className: cx(styles.nutritionCta), children: _jsx(Button, { onClick: () => {
                                                setNutritionVisible(true);
                                            }, underlined: true, nutrition: true, variant: "secondary", children: "Nutrition Label" }) })), productType === PROTEIN && (_jsx("div", { className: cx(styles.nutritionCta), children: _jsx(Button, { onClick: () => {
                                                setFlavorNutritionVisible(true);
                                            }, underlined: true, nutrition: true, variant: "secondary", children: "Flavor Boost Nutrition Labels" }) }))] })] }))] }), _jsx("div", { className: [styles.addToCart, editMode && styles.editMode].join(" "), children: _jsx(Button, { color: "court", onClick: () => {
                        // if sku exists, add to cart
                        if (currentProduct) {
                            if (!hasItemInCart) {
                                posthog.capture("add_to_cart");
                            }
                            if (productType === PROTEIN) {
                                // check if there are too many or too few flavor sticks
                                const numberFlavorSticks = sumValues(values[PROTEIN].FLAVORS);
                                if (numberFlavorSticks > quantity * 2) {
                                    addToast(`Please deselect ${numberFlavorSticks - quantity * 2} flavor boosts to continue`, "error");
                                    setIsOpen(true);
                                    return;
                                }
                                if (numberFlavorSticks < quantity * 2) {
                                    addToast(`Please select ${quantity * 2 - numberFlavorSticks} additional flavor boosts to continue`, "error");
                                    setIsOpen(true);
                                    return;
                                }
                                currentProduct.flavor = displayedFlavorNames;
                            }
                            const updatedProduct = {
                                ...currentProduct,
                                formValues: structuredClone(values),
                            };
                            if (productType === "PROTEIN") {
                                updatedProduct.flavor = formatFlavorBoostsString(values[PROTEIN].FLAVORS);
                            }
                            if (skuToModify && editMode) {
                                addToSubscription(updatedProduct.productId, skuToModify);
                            }
                            else {
                                addToSubscription(updatedProduct.productId);
                            }
                            toggleDrawer && toggleDrawer();
                        }
                        else {
                            console.log("no current product!");
                        }
                    }, children: editMode ? ("Save Updates") : (_jsxs(_Fragment, { children: [hasItemInCart ? "Save Updates" : "Add to subscription", " ", "\u00A0\u00A0|\u00A0\u00A0", " ", currentProduct?.unit_prices &&
                                formatPrice(currentProduct?.unit_prices[quantity >= 2 ? 2 : 1] * quantity)] })) }) }), _jsx(DrawerComponent, { open: nutritionVisible, toggleDrawer: (val) => () => setNutritionVisible(val), children: _jsx("div", { style: { padding: "24px", margin: "0 auto" }, children: _jsx("img", { src: currentProduct?.nutrition_facts_image, alt: "Nutrition facts", style: { maxWidth: "300px", margin: "0 auto" } }) }) }), _jsx(DrawerComponent, { open: flavorNutritionVisible, toggleDrawer: (val) => () => setFlavorNutritionVisible(val), children: _jsxs("div", { style: { padding: "24px", margin: "0 auto" }, children: [_jsx("div", { className: styles.flavorDrawerSubhed, children: "Flavor Boosts" }), _jsx("div", { className: styles.flavorDrawerHed, children: "Nutrition Facts" }), _jsx(FlavorAccordion, {}), _jsxs("div", { className: styles.varietyPackDisclaimer, children: [_jsx("b", { children: "Variety pack consists of:" }), _jsx("br", {}), " Rich Cocoa, Sea Salt Caramel, Madagascar Vanilla, Caff\u00E9 Mocha, Strawberry Cream, Chocolate Peanut Butter, Cookies & Cream and Cinnamon Toast"] })] }) })] }));
};
export default Customizer;
